import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imports_table = _resolveComponent("imports-table")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: `${_ctx.platform} Imports`,
    size: "md",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_imports_table, {
        "account-id": _ctx.accountId,
        flat: ""
      }, null, 8, ["account-id"])
    ]),
    _: 1
  }, 8, ["title"]))
}